import React, { useRef, useState, useEffect } from 'react';
import ResponsiveDrawer from '../Drawer/drawer';
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DeleteIcon from '@mui/icons-material/Delete';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import { useOrderDraft } from './OrderDraftContext';
import { createOrder, uploadSignatureImage, uploadPDF, formatDate } from '../../ReusableComponents/functions';
import { generateOrderPDF } from './PDFGenerator';
import { Bounce, ToastContainer, toast } from 'react-toastify';

const TERMS_LIST = [
    { num: 1, title: "SECURITY AGREEMENT", text: "To secure the prompt payment and full and faithful performance of the Purchase Order and related Invoices, Purchaser/Debtor grants to Kinderland a security interest in and to, and pledges and assigns to Kinderland, under the Uniform Commercial Code (the \"UCC\") all of Purchaser/Debtor's now owned and hereafter acquired right, title, and interest in the goods described herein and all of the Proceeds arising from the goods described herein (the \"Collateral\"). Purchaser/Debtor authorizes Kinderland, Inc. to file a UCC-1 Financing Statement in the public records." },
    { num: 2, title: "ONGOING PERSONAL GUARANTEE", text: "THE UNDERSIGNED DOES JOINTLY AND SEVERALLY PERSONALLY GUARANTEE TO PAY AND BE RESPONSIBLE FOR PAYMENT (AND NOT MERELY COLLECTION) OF ALL SUMS, BALANCES, AND ACCOUNTS DUE SELLER, INCLUDING INTEREST, COLLECTION COSTS, AND/OR ATTORNEY FEES ON AN ONGOING, CONTINUOUS BASIS FOR ALL ORDERS PLACED WITH KINDERLAND. TO THE EXTENT PERMITTED BY LAW, THIS PERSONAL GUARANTEE SHALL EXTEND TO ALL OWNERS, OFFICERS, MANAGING MEMBERS, SHAREHOLDERS, PARTNERS, AND OTHER INTERESTED PARTIES OF THE PURCHASING ENTITY." },
    { num: 3, title: "LIMITED WARRANTY", text: "Brands distributed by Kinderland, Inc. are under a limited warranty for manufacturer's defects on the upper for a period of 6 months from the date of shipment by Kinderland, Inc. This warranty only applies to the original end-user customer that purchased the product at an authorized retailer, and to no other person or entity (including without limitation any direct or indirect transferees of the product from customer or from an unauthorized retailer). This warranty shall be null and void as to any and all transshipped or otherwise diverted or grey market products. To benefit from the warranty, the claimant must provide a receipt from an authorized retailer. All claims must be made through the authorized retailer at which the product was purchased. The authorized retailer shall make the initial determination as to whether the defect is a manufacturer's defect. Kinderland, Inc. reserves the right to make the final determination on all claims. Repair or replacement of defective product through the authorized retailer is the exclusive remedy. Ornaments are specifically excluded from the warranty. Full version of warranty and exclusions is available at http://www.venettini.com/warranty-return-policy/\nBY PURCHASING KINDERLAND, INC. PRODUCTS, YOU AGREE TO SERVICE THE LIMITED WARRANTY." },
    { num: 4, title: "SOLVENCY", text: "PURCHASER WARRANTS AND REPRESENTS TO SELLER, THAT WE ARE SOLVENT AND ABLE TO PAY OUR OBLIGATIONS AS THEY BECOME DUE. WE WILL NOTIFY SELLER IMMEDIATELY IF WE BECOME INSOLVENT, AND THAT SELLER CAN RELY ON THIS CONTINUING REPRESENTATION OF SOLVENCY IN SHIPPING PRODUCTS TO PURCHASER." },
    { num: 5, title: "ATTORNEY'S FEES", text: "PURCHASER AGREES TO PAY ALL COSTS AND ATTORNEY'S FEES INCURRED BY SELLER IN RELATION TO THE INTERPRETATION, CONSTRUCTION, OR ENFORCEMENT OF ANY OR ALL OF OUR OBLIGATIONS UNDER THIS PURCHASE ORDER OR RELATED INVOICE, WHETHER OR NOT SUIT IS FILED." },
    { num: 6, title: "INTEREST AND FEES", text: "In the event purchaser does not pay the amount due pursuant to the terms of the agreement between purchaser and seller, purchaser agrees to pay a delinquent interest charge of 1.5% per month on the unpaid balance of the highest rate permitted by law, whichever is greater. Credit, debit, or charge card payments shall incur a 3.25% Convenience Fee." },
    { num: 7, title: "RETURNS NOT POSSIBLE FOR", text: "We will not accept returns of shoes that have been worn and are peeling anywhere. We will not accept returns for stitching issues unless the area around the stitch that has become undone is clearly free of scraping and wear. We will not accept returns for ornament issues." },
    { num: 8, title: "RETURN CREDITS", text: "Please note and advise the appropriate personnel within your company that although Kinderland, Inc. may have authorized a return and issued a call tag, label, etc., it does not mean that you will receive credit for every item returned to us. Once returns are received by our warehouse, they are inspected and a determination is made whether or not the return falls within our limited warranty for manufacturer's defects. If Kinderland, Inc. determines that the returned shoe has a manufacturer's defect, then a credit is issued. Otherwise, no credit is issued for the shoe. Kinderland, Inc. reserves the right to make such determinations at its sole discretion, and Kinderland, Inc.'s determination is final." },
    { num: 9, title: "SHORT SHIPMENT/DISCREPANCIES", text: "Kinderland, Inc. must be advised in writing of any short shipments or lost boxes within 5 days of retailer receiving the shipment. It is vital when receiving the shipment from the carrier that retailer count and inspect the boxes and note with the driver any missing, damaged, or tampered boxes. If retailer signs and receives the shipment without an acknowledged discrepancy (missing, damaged, tampered box) from the driver, retailer will not have a basis for a claim, and Kinderland, Inc. will expect full payment of the related invoice. Similarly, Kinderland, Inc. must receive within 5 days of retailer receiving the shipment, in writing, any discrepancies between the shoes retailer receives and the packing list for that shipment. We will not accommodate short shipment and discrepancy claims beyond the 5 day period." },
    { num: 10, title: "TRANSSHIPMENT", text: "Reselling to other retailers or wholesalers or transshipping merchandise purchased from Kinderland, Inc. is strictly prohibited. Violation of this clause will result in the termination of your account and potential legal action. THE SALE OF PRODUCTS DISTRIBUTED BY KINDERLAND IS RESTRICTED TO AUTHORIZED RETAILERS ONLY." },
    { num: 11, title: "VENUE AND JURISDICTION", text: "The parties (a) hereby irrevocably submit to the process, jurisdiction and venue of the courts of the State of Florida, Miami-Dade County, and to the process, jurisdiction and venue of the United States District Court for the Southern District of Florida, for the purposes of suit, action or other proceedings arising out of or relating to this Agreement or the subject matter hereof, and (b) without limiting the generality of the foregoing, hereby voluntarily and knowingly waive and agree not to assert by way of motion, defense or otherwise in any suit, action or proceeding any claim that it is not subject to the jurisdiction of the above-named courts, that such suit, action or proceeding is brought in an inconvenient forum or that the venue of such suit, action or proceedings is improper." },
    { num: 12, title: "WAIVER", text: "No waiver of any of these provisions shall be deemed or constitute a waiver of any other provision, whether or not similar, nor shall any waiver constitute a continuing waiver." },
    { num: 13, title: "WAIVER OF TRIAL BY JURY", text: "The parties knowingly, irrevocably, voluntarily and intentionally waive any right they may have to a trial by jury in respect of any action, proceeding or counterclaim based on this Agreement, or arising out of, under or in connection with this Agreement, or any course of conduct, course of dealing, statements (whether verbal or written) or actions of any party hereto." },
    { num: 14, title: "FACSIMILE AND EMAIL", text: "This Agreement may be executed via facsimile, email, or other electronic means, in which event signatures shall be treated as original signatures for all purposes." },
    { num: 15, title: "AMENDMENTS", text: "Kinderland, Inc. reserves the right to amend these terms at any time." }
];

const DigitalSignature = () => {
    const drawerWidth = 240;
    const navigate = useNavigate();
    const { draft, setSignature, updateShippingDetails } = useOrderDraft();

    const canvasRef = useRef(null);
    const [isDrawing, setIsDrawing] = useState(false);
    const [agreed, setAgreed] = useState(false);
    const [openTerms, setOpenTerms] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("Please Wait... Generating Pdf.");

    // Setup canvas dimension resolution
    useEffect(() => {
        const canvas = canvasRef.current;
        if (canvas) {
            const rect = canvas.getBoundingClientRect();
            canvas.width = rect.width;
            canvas.height = rect.height;

            const ctx = canvas.getContext('2d');
            ctx.strokeStyle = '#1a1a1a'; // White signature line
            ctx.lineWidth = 3;
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';
        }
    }, []);

    // Resize canvas on screen orientation change or resize
    useEffect(() => {
        const handleResize = () => {
            const canvas = canvasRef.current;
            if (canvas) {
                // Save current drawing
                const tempCanvas = document.createElement('canvas');
                tempCanvas.width = canvas.width;
                tempCanvas.height = canvas.height;
                const tempCtx = tempCanvas.getContext('2d');
                tempCtx.drawImage(canvas, 0, 0);

                const rect = canvas.getBoundingClientRect();
                canvas.width = rect.width;
                canvas.height = rect.height;

                const ctx = canvas.getContext('2d');
                ctx.strokeStyle = '#1a1a1a';
                ctx.lineWidth = 3;
                ctx.lineCap = 'round';
                ctx.lineJoin = 'round';
                ctx.drawImage(tempCanvas, 0, 0, rect.width, rect.height);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const startDrawing = (e) => {
        e.preventDefault();
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        const rect = canvas.getBoundingClientRect();

        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;

        const x = clientX - rect.left;
        const y = clientY - rect.top;

        ctx.beginPath();
        ctx.moveTo(x, y);
        setIsDrawing(true);
    };

    const draw = (e) => {
        if (!isDrawing) return;
        e.preventDefault();
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        const rect = canvas.getBoundingClientRect();

        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;

        const x = clientX - rect.left;
        const y = clientY - rect.top;

        ctx.lineTo(x, y);
        ctx.stroke();
    };

    const stopDrawing = () => {
        setIsDrawing(false);
    };

    const handleClear = () => {
        const canvas = canvasRef.current;
        if (canvas) {
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
    };

    const handleNext = async () => {
        // validation 
        if (!agreed) {
            toast.error("Please agree to the terms and conditions", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Bounce,
            });
            return;
        }
        const canvas = canvasRef.current;
        if (!canvas) return;

        setLoading(true);
        setLoadingMessage("Submitting order details...");

        try {
            // Create a temporary offscreen canvas to combine the background color and signature lines
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = canvas.width;
            tempCanvas.height = canvas.height;
            const tempCtx = tempCanvas.getContext('2d');

            // Draw solid background color matching the canvas viewboard
            tempCtx.fillStyle = '#00000000';
            tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

            // Overlay the user signature strokes
            tempCtx.drawImage(canvas, 0, 0);

            // 1. Get drawing signature as base64 and save in context
            const sigBase64 = tempCanvas.toDataURL("image/png");
            setSignature(sigBase64);

            // 2. Submit order metadata
            const response = await createOrder(draft.cartItems);
            if (!response || !response.order_number) {
                throw new Error("Failed to create order. Backend did not return order number.");
            }
            const orderNumber = response.order_number;

            // 3. Upload signature image file
            setLoadingMessage("Uploading digital signature...");
            const blobBin = atob(sigBase64.split(',')[1]);
            const array = [];
            for (let i = 0; i < blobBin.length; i++) {
                array.push(blobBin.charCodeAt(i));
            }
            const signatureBlob = new Blob([new Uint8Array(array)], { type: 'image/png' });
            const signatureFile = new File([signatureBlob], `sign_${orderNumber}.png`, { type: 'image/png' });
            await uploadSignatureImage(signatureFile, orderNumber);

            // 4. Generate PDF client-side and upload
            setLoadingMessage("Please Wait... Generating Pdf.");
            const orderDateStr = formatDate(new Date()); // MM-DD-YYYY

            // Build temporary draft object with signature to generate PDF
            const tempDraft = {
                ...draft,
                signature: sigBase64
            };

            const doc = await generateOrderPDF(tempDraft, orderNumber, orderDateStr);
            const pdfBlob = doc.output('blob');
            const cleanStoreName = (draft?.selectedCustomer?.StoreName || '').trim() || 'Store';
            const pdfFile = new File([pdfBlob], `${cleanStoreName}_${orderNumber}.pdf`, { type: 'application/pdf' });
            const pdfDetails = await uploadPDF(pdfFile, orderNumber);

            // Save order data to draft state to render summary
            updateShippingDetails({
                orderNumber,
                orderDate: orderDateStr
            });

            setLoading(false);
            navigate('/Order');
        } catch (error) {
            console.error("Order processing failed: ", error);
            alert("Order processing failed. Please try again.");
            setLoading(false);
        }
    };

    return (
        <div className="mx-4">
            <ResponsiveDrawer heading="Digital Signature - Create Order" />
            <Box
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                }}
                component="main"
            >
                <Toolbar />

                {/* Loading overlay */}
                {loading && (
                    <Box
                        sx={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            zIndex: 9999,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 3
                        }}
                    >
                        <CircularProgress size={60} thickness={4} />
                        <Typography variant="h6" fontWeight="bold" color="primary">
                            {loadingMessage}
                        </Typography>
                    </Box>
                )}

                {/* Navigation Bar */}
                <Box sx={{ display: 'flex', justifyItems: 'center', justifyContent: 'space-between', mx: 5, mt: 5, mb: 3 }}>
                    <Button variant="contained" startIcon={<ArrowBackIcon />} onClick={() => navigate('/ShippingDetails')}>
                        Back
                    </Button>
                    <Typography variant="h5" fontWeight="bold" sx={{ color: 'text.primary' }}>
                        Customer Signature
                    </Typography>
                    <Button
                        variant="contained"
                        color="success"
                        endIcon={<ArrowForwardIcon />}
                        onClick={handleNext}
                        sx={{ fontWeight: 'bold' }}
                    >
                        Next
                    </Button>
                </Box>

                <Box sx={{ px: 5, pb: 5 }}>
                    <Grid container spacing={4} justifyContent="center">
                        <Grid item xs={12} md={9} lg={8}>
                            <Paper sx={{ p: 4, borderRadius: 2, border: '1px solid rgba(0, 0, 0, 0.08)' }}>
                                <Typography variant="h6" fontWeight="bold" sx={{ mb: 2, color: 'text.primary' }}>
                                    Please Sign Below
                                </Typography>

                                {/* Accent-colored signature pad canvas wrapper */}
                                <Box
                                    sx={{
                                        position: 'relative',
                                        width: '100%',
                                        height: 320,
                                        backgroundColor: '#4DB6AC', // Solid accent colored background
                                        borderRadius: 2,
                                        overflow: 'hidden',
                                        boxShadow: 'inset 0 4px 12px rgba(0,0,0,0.15)',
                                        border: '2px solid rgba(0, 0, 0, 0.1)'
                                    }}
                                >
                                    <canvas
                                        ref={canvasRef}
                                        onMouseDown={startDrawing}
                                        onMouseMove={draw}
                                        onMouseUp={stopDrawing}
                                        onMouseLeave={stopDrawing}
                                        onTouchStart={startDrawing}
                                        onTouchMove={draw}
                                        onTouchEnd={stopDrawing}
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            cursor: 'crosshair',
                                            touchAction: 'none'
                                        }}
                                    />

                                    {/* Signature clear button */}
                                    <Button
                                        variant="contained"
                                        color="error"
                                        size="small"
                                        startIcon={<DeleteIcon />}
                                        onClick={handleClear}
                                        sx={{
                                            position: 'absolute',
                                            bottom: 16,
                                            right: 16,
                                            boxShadow: 3
                                        }}
                                    >
                                        Clear
                                    </Button>
                                </Box>

                                {/* Terms agreement checkbox row */}
                                <Box sx={{ mt: 3, display: 'flex', alignItems: 'center' }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={agreed}
                                                onChange={(e) => setAgreed(e.target.checked)}
                                                color="primary"
                                            />
                                        }
                                        label={
                                            <Typography variant="body2" color="text.secondary">
                                                I agree to the wholesale{' '}
                                                <Link
                                                    component="button"
                                                    variant="body2"
                                                    fontWeight="bold"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setOpenTerms(true);
                                                    }}
                                                    sx={{ verticalAlign: 'baseline' }}
                                                >
                                                    terms & conditions
                                                </Link>
                                            </Typography>
                                        }
                                    />
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            {/* Terms and Conditions Dialog Modal */}
            <Dialog open={openTerms} onClose={() => setOpenTerms(false)} maxWidth="md" fullWidth>
                <DialogTitle sx={{ fontWeight: 'bold', borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
                    KINDERLAND - Terms & Conditions
                </DialogTitle>
                <DialogContent sx={{ p: 4, maxHeight: '60vh' }}>
                    <Typography variant="subtitle2" align="center" fontWeight="bold" sx={{ mb: 3 }}>
                        TERMS AND CONDITIONS OF WHOLESALE AND DISTRIBUTOR TRANSACTIONS
                    </Typography>
                    {TERMS_LIST.map(item => (
                        <Box key={item.num} sx={{ mb: 3.5 }}>
                            <Typography variant="subtitle2" fontWeight="700" color="primary" sx={{ mb: 1 }}>
                                {item.num}. {item.title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" align="justify" sx={{ lineHeight: 1.6, whiteSpace: 'pre-line' }}>
                                {item.text}
                            </Typography>
                        </Box>
                    ))}
                </DialogContent>
                <DialogActions sx={{ p: 2, borderTop: '1px solid rgba(0,0,0,0.08)' }}>
                    <Button onClick={() => setOpenTerms(false)} variant="contained" color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <ToastContainer />
        </div>
    );
};

export default DigitalSignature;
